module.exports = __webpack_public_path__ + "static/media/img14.abc69523.JPG";